import { BaseFileModel } from '../data';

export interface DigitalFilingFilesPayloadModel {
  files: BaseFileModel[];
}
